import { Grid, Typography } from "@mui/material";
import { ScrollableDialogProps } from "../../ui/Dialogs";
import { CustomTextFieldNoForm, LoaderComponent } from "../../ui";
import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { Contrato, CurrentPuertoNap, EstadoPuertoNap } from "@/shared/interfaces";
import { UseFormReturn } from "react-hook-form";
import { useEffect, useState } from "react";


interface IShowClienteByIdContratoModalProps {
  form: UseFormReturn<any>;
  dataContrato:Pick<Contrato, "id_contrato" | "cliente_data"> | null;
  open?: boolean;
  setOpen?: any
}

const ShowClienteByIdContratoModal: React.FunctionComponent<IShowClienteByIdContratoModalProps> = ({
  form,
  dataContrato,
  open = false,
  setOpen 
}) => {

  const [newContratoId, setNewContratoId] = useState<string>("");



  const SaveNewContractPuerto = () => {
    const dataRow = form.getValues()?.currentRowSelected;
    const newArrayPuertos = form?.getValues()?.puertosTabla?.map((x:CurrentPuertoNap)=>{
      if(x.puerto==dataRow.puerto){
        x.estado=EstadoPuertoNap.OCUPADO;
        x.id_cliente_contrato=newContratoId
        return x
      }
      return x
    })
    form.reset({
      ...form?.getValues(),
      puertosTabla : newArrayPuertos
    })
    setOpen(false)
  }
  useEffect(() => {
    if(!open){
      setNewContratoId("")
    }
  }, [open]);
  

  return <>

    {open && (
      <ScrollableDialogProps
        open={open}
        title="Información de Cliente"
        cancelTextBtn="Cerrar"
        confirmTextBtn="Guardar"
        onClose={() => { setOpen(false) }}
        onConfirm={()=>SaveNewContractPuerto()}
        minWidth="50%"
        contentNode={
          <Grid container item spacing={2}>
            {
                // dataContrato?.id_contrato
                form.getValues()?.currentRowSelected?.id_cliente_contrato?
                <>
                  {
                    dataContrato?.id_contrato?
                    <>
                      <Grid item {...gridSizeMdLg6}>
                        <CustomTextFieldNoForm
                          label="Identificador de Contrato"
                          value={newContratoId || dataContrato?.id_contrato || "N/A"}
                          onChangeCustom={(e)=>{
                            const value = e.target.value
                            setNewContratoId(value)

                          }}
                          shrink={true}
                        />
                      </Grid>
                      <Grid item {...gridSizeMdLg6}>
                        <CustomTextFieldNoForm
                          label="Identificación"
                          value={!!!newContratoId ? dataContrato?.cliente_data?.identificacion :""}
                          shrink={true}
                        />
                      </Grid>
                      <Grid item {...gridSizeMdLg12}>
                        <CustomTextFieldNoForm
                          label="Razón Social"
                          value={!!!newContratoId ? dataContrato?.cliente_data?.razon_social :""}
                          shrink={true}
                        />
                      </Grid>
                    </>
                    :<LoaderComponent/>
                  }
                </>
              :
              <>
                <Grid item {...gridSizeMdLg12}>
                  <Typography>
                    No esta asignada aún
                  </Typography>
                </Grid>
                <Grid item {...gridSizeMdLg6}>
                  <CustomTextFieldNoForm
                    label="Identificador de Contrato"
                    value={newContratoId || dataContrato?.id_contrato || "N/A"}
                    onChangeCustom={(e)=>{
                      const value = e.target.value
                      setNewContratoId(value)
                    }}
                    shrink={true}
                  />
                </Grid>
                <Grid item {...gridSizeMdLg6}>
                  <CustomTextFieldNoForm
                    label="Identificación"
                    disabled
                    value={!!!newContratoId ? dataContrato?.cliente_data?.identificacion :""}
                    shrink={true}
                  />
                </Grid>
                <Grid item {...gridSizeMdLg12}>
                  <CustomTextFieldNoForm
                    label="Razón Social"
                    disabled
                    value={!!!newContratoId ? dataContrato?.cliente_data?.razon_social :""}
                    shrink={true}
                  />
                </Grid>
              </>
            }
          </Grid>

        }
      />
      )
    }
  </>

};

export default ShowClienteByIdContratoModal;
